import React, { Component, Fragment } from 'react';
import InventoryHeader from './InventoryHeader';
import { inject, observer } from 'mobx-react';
import { BrowserRouter as Router, Redirect } from 'react-router-dom';
import Loading from '../Loading';
import Modal from '../Modal';
import moment from 'moment';

@inject('StockTransferStoreItems')
@observer
class InventoryReceiveStockOdoo extends Component {
    state = { showConfirmationModal: false, formRefReady: false };

    componentDidMount = () => {
        const {
            StockTransferStoreItems: { handleGetReceiptProducts, receipt_id }
        } = this.props;
        handleGetReceiptProducts(receipt_id);
    };

    handleShowConfirmationModal = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        // Use browser built-in validation; show tooltip and red highlight
        if (this.formRef) {
            if (!this.formRef.checkValidity()) {
                this.formRef.reportValidity();
                return;
            }
        }
        this.setState({ showConfirmationModal: true });
    };

    handleCloseConfirmationModal = () => {
        this.setState({ showConfirmationModal: false });
    };

    setQuantity = (id, event) => {
        const {
            StockTransferStoreItems
        } = this.props;
        let receiptProducts = StockTransferStoreItems.receiptProducts;
        const val = event.target.value;
        const product = receiptProducts.filter(p => p.id == id)[0];
        if (val === '') {
            product.done_value = undefined;
        } else {
            const parsed = parseFloat(val);
            product.done_value = isNaN(parsed) ? undefined : parsed;
        }
        StockTransferStoreItems.receiptProducts = receiptProducts;
    }

    saveDoneValue = () => {
        this.setState({ showConfirmationModal: false });
        const {
            StockTransferStoreItems: { handleSaveDoneValue }
        } = this.props;
        handleSaveDoneValue();
    }
    
    render() {
        const { showConfirmationModal } = this.state;

        const {
            StockTransferStoreItems: { receiptProducts, receipt_id, loading }
        } = this.props;

        if (loading) {
            return <Loading />
        }

        if (!receipt_id){
            return( <Redirect to="/inventory/receive-stock" /> ) 
        }

        return (
            <Fragment>
            <InventoryHeader title="Receive New Stock" />
            <form ref={(el) => { this.formRef = el; if (el && !this.state.formRefReady) { this.setState({ formRefReady: true }); } }} onSubmit={this.handleShowConfirmationModal}>
                <table className="fs--medium table table-striped table-bordered" >
                    <thead>
                        <tr>
                            <th> Product </th>
                            <th> Demand </th>
                            <th> UOM </th>
                            <th> Scheduled Date </th>
                            <th> Done </th>
                        </tr>
                    </thead>
                    <tbody>
                    {receiptProducts.map((product, index) => (
                        <tr key={product.id}>
                            <td> {product.product_name} </td>
                            <td> {product.demand} </td>
                            <td> {product.uom} </td>
                            <td> {product.scheduled_date ? moment(product.scheduled_date).format("DD/MM/YYYY hh:mm A") : null}</td>
                            <td> 
                                <input
                                    className='border--rounded border--solid text--center center--horizontal ps'
                                    type='number'
                                    name={`done_${product.id}`}
                                    min={0}
                                    step='any'
                                    required
                                    value={typeof product.done_value === 'number' && !isNaN(product.done_value) ? product.done_value : ''}
                                    onChange={this.setQuantity.bind(this, product.id)}
                                />
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                    <div className="row col-xs-12 text--center mtm" >
                        <button
                            type="submit"
                            className="btn btn-primary"
                        >
                            Confirm receipt
                        </button>
                    </div>
            </form>

                {showConfirmationModal && (
                    <Modal>
                        <h3>
                            After saving, you cannot make any more changes. Are you sure the quantities are correct?
                        </h3>
                        <div className="display--flex justify--space-around mtl">
                            <button
                                className="btn ms"
                                onClick={this.handleCloseConfirmationModal}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary ms"
                                onClick={this.saveDoneValue}
                            >
                                Confirm
                            </button>
                        </div>
                    </Modal>
                )}
            </Fragment>
        );
    }
}

export default InventoryReceiveStockOdoo;
